export default __webpack_public_path__ + "static/media/time-execution.830bf435.png";